import React, { useContext } from 'react'
import PropTypes from 'prop-types'
import { Grid, FormHelperText, Typography, Tooltip } from '@material-ui/core'
import BitrateSelect from '../QuicklinkItem/BitrateSelect'
import NumberField from '../../../NumberField'
import { S3_DOWNLOADS_LABEL } from '../../../../strings/labels'
import { CalculatorContext } from '../../../Context/CalculatorContext'

const S3Downloads = ({ s3Downloads, bitrate, onChange }) => {
    const { tooltips } = useContext(CalculatorContext)
    return (
        <Grid container style={{ marginBottom: '12' }}>
            <Grid item xs={12}>
                <Tooltip title={tooltips.s3Downloads}>
                    <Typography gutterBottom color={'textSecondary'}>
                        {S3_DOWNLOADS_LABEL}
                    </Typography>
                </Tooltip>
            </Grid>
            <Grid container>
                <Grid item xs={6}>
                    <NumberField
                        onChange={(value) =>
                            onChange((item) => (item.s3Downloads = value))
                        }
                        value={s3Downloads}
                    />
                    <FormHelperText>Downloads</FormHelperText>
                </Grid>
                <Grid item xs={6}>
                    <BitrateSelect
                        onChange={(value) =>
                            onChange((item) => (item.bitrate = value))
                        }
                        value={bitrate}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

S3Downloads.propTypes = {
    s3Downloads: PropTypes.number.isRequired,
    bitrate: PropTypes.number.isRequired,
    onChange: PropTypes.func.isRequired
}

export default S3Downloads
